// client/src/pages/analise.jsx
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import styles from '../App.module.css';
import {
  format,
  parse,
  startOfWeek as dfnsStartOfWeek,
  getDay,
  addMinutes,
  isSameMonth
} from 'date-fns';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import api from '../api/axios';
import RegistroAnalise from "../components/registroAnalise";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { ptBR } from 'date-fns/locale';

const locales = { 'pt-BR': ptBR };

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: (date) => dfnsStartOfWeek(date, { weekStartsOn: 1 }),
  getDay,
  locales,
});

function Analise() {
  const [agendamentos, setAgendamentos] = useState([]);
  const [events, setEvents] = useState([]);
  const [view, setView] = useState('month');
  const [currentDate, setCurrentDate] = useState(new Date());

  const [showRegistro, setShowRegistro] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const [showEventModal, setShowEventModal] = useState(false);
  const [selectedAg, setSelectedAg] = useState(null);
  const [editData, setEditData] = useState(null);

  const [showComprovanteAnalise, setShowComprovanteAnalise] = useState(false);
  const [comprovanteAnalise, setComprovanteAnalise] = useState(null);

  const [usuariosByCpf, setUsuariosByCpf] = useState(new Map());

  const [uniqueClientLink, setUniqueClientLink] = useState("");



  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : '';

  const formats = useMemo(
    () => ({
      timeGutterFormat: (date, culture, loc) => loc.format(date, 'H', culture),
      dayHeaderFormat: 'EEEE, dd/MM',
      dayRangeHeaderFormat: ({ start, end }, culture, loc) =>
        `${loc.format(start, 'dd/MM', culture)} – ${loc.format(end, 'dd/MM', culture)}`
    }),
    []
  );

  const generateUniqueClientLink = useCallback(async (clienteId) => {
    if (!clienteId) return '';

    try {
      const tokenResponse = await api.post('/cliente/gerar-token', {
        clienteId
      });

      if (tokenResponse.data?.status && tokenResponse.data?.token) {
        return `${origin}/formulario/${tokenResponse.data.token}`;
      }

      return '';
    } catch (error) {
      console.error('Erro ao gerar link seguro:', error);
      return '';
    }
  }, [origin]);



  const fromDiaHorario = useCallback((dia, hora) => {
    if (!dia || !hora) return new Date(NaN);
    const dataStr = String(dia).split('T')[0];
    return new Date(`${dataStr}T${hora}`);
  }, []);

  const openRegistro = useCallback((date) => {
    const d = date instanceof Date ? date : new Date();
    setSelectedDate({
      dataDia: format(d, "yyyy-MM-dd"),
      dataHorario: format(d, "HH:mm"),
    });
    setEditData(null);
    setShowRegistro(true);
  }, []);

  const closeRegistro = useCallback(() => {
    setShowRegistro(false);
    setEditData(null);
  }, []);

  const copyComprovanteAnalise = async () => {
    try {
      const el = document.getElementById('copiarAnaliseExterno');
      const text = el ? el.innerText : '';
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else if (el) {
        const r = document.createRange();
        r.selectNode(el);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(r);
        document.execCommand('copy');
        sel.removeAllRanges();
      }
      NotificationManager.success('Comprovante copiado!', 'Sucesso');
    } catch {
      NotificationManager.error('Não foi possível copiar o comprovante.', 'Erro');
    }
  };

  const openEditarAgendamento = useCallback((ag) => {
    setSelectedDate({
      dataDia: ag.dataDia,
      dataHorario: (ag.dataHorario || '').slice(0, 5)
    });

    setEditData({
      id: ag.id,
      vendedor: ag.vendedor,
      produtor: ag.produtor,
      client_id: ag.client_id,
      dataDia: ag.dataDia,
      dataHorario: (ag.dataHorario || '').slice(0, 5),
      observacoes: ag.observacoes,
      statusAnalise: ag.statusAnalise,
      tipo: ag.tipo || 'analise de perfil',
    });

    setShowEventModal(false);
    setShowRegistro(true);
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeRegistro();
    };

    if (showRegistro) {
      window.addEventListener('keydown', onKeyDown);
    }

    return () => window.removeEventListener('keydown', onKeyDown);
  }, [showRegistro, closeRegistro]);

  const messages = {
    allDay: 'Dia inteiro',
    previous: 'Anterior',
    next: 'Próximo',
    today: 'Hoje',
    month: 'Mês',
    week: 'Semana',
    day: 'Dia',
    agenda: 'Agenda',
    date: 'Data',
    time: 'Hora',
    event: 'Evento',
    noEventsInRange: 'Sem eventos neste período',
  };

  useEffect(() => {
    (async () => {
      try {
        const resp = await api.get('/vendedores-produtores');
        if (resp.data && Array.isArray(resp.data.data)) {
          const map = new Map();
          resp.data.data.forEach((u) => {
            const cpf = String(u.cpf || '').replace(/\D/g, '');
            if (cpf) map.set(cpf, u.nome);
          });
          setUsuariosByCpf(map);
        }
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const PALETA = useMemo(() => ([
    '#162768', '#FF0000', '#4DB6AC', '#9575CD', '#FFD54F',
    '#64B5F6', '#81C784', '#F06292', '#BA68C8', '#4DD0E1',
    '#A1887F', '#90A4AE', '#FF7043', '#26A69A', '#D4E157'
  ]), []);

  const colorByColabRef = useRef(new Map());

  const hashColor = useCallback((str) => {
    let h = 0;
    for (let i = 0; i < str.length; i += 1) {
      h = (h * 31 + str.charCodeAt(i)) | 0;
    }
    const idx = Math.abs(h) % PALETA.length;
    return PALETA[idx];
  }, [PALETA]);

  const getColorFor = useCallback((nome) => {
    if (!nome) return '#90A4AE';

    if (!colorByColabRef.current.has(nome)) {
      const used = new Set(colorByColabRef.current.values());
      const livre = PALETA.find((c) => !used.has(c));
      colorByColabRef.current.set(nome, livre || hashColor(nome));
    }

    return colorByColabRef.current.get(nome);
  }, [PALETA, hashColor]);

  const getTextColor = useCallback((bg) => {
    const c = bg.replace('#', '');
    const r = parseInt(c.substring(0, 2), 16);
    const g = parseInt(c.substring(2, 4), 16);
    const b = parseInt(c.substring(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 160 ? '#111' : '#fff';
  }, []);

  const minTime = useMemo(() => {
    const d = new Date();
    d.setHours(8, 0, 0, 0);
    return d;
  }, []);

  const maxTime = useMemo(() => {
    const d = new Date();
    d.setHours(21, 0, 0, 0);
    return d;
  }, []);

  const getAgendamentosAnalise = useCallback(async () => {
    try {
      const resAgendamentos = await api.get('/agendamentosAnalise');
      const data = Array.isArray(resAgendamentos.data) ? resAgendamentos.data : [];

      setAgendamentos(data);

      const parsed = data.map((item) => {
        const colabCpf = String(item.produtor || '').replace(/\D/g, '');
        const cleanDia =
          typeof item.dataDia === 'string'
            ? item.dataDia.split('T')[0]
            : item.dataDia;

        const startLocal = fromDiaHorario(cleanDia, item.dataHorario);

        if (isNaN(startLocal)) {
          console.warn("Data inválida no evento: ", item);
        }

        return {
          id: item.id,
          title: `${item.clienteNome || 'Agendamento'}${item.tipo ? ` (${item.tipo})` : ''}`,
          start: startLocal,
          end: addMinutes(startLocal, 60),
          allDay: false,
          colaborador: colabCpf,
          tipo: item.tipo || 'analise de perfil',
        };
      });

      setEvents(parsed);
    } catch (error) {
      NotificationManager.error('Erro ao buscar agendamentos de análise', 'Erro');
    }
  }, [fromDiaHorario]);

  useEffect(() => {
    getAgendamentosAnalise();
  }, [getAgendamentosAnalise]);

  const handleEventClick = useCallback((event) => {
    const ag = agendamentos.find((a) => a.id === event.id);
    if (!ag) return;
    setSelectedAg(ag);
    setShowEventModal(true);
  }, [agendamentos]);

  const excluirAgendamento = async (id) => {
    const ok = window.confirm('Deseja excluir este agendamento?');
    if (!ok) return;

    try {
      await api.post('/deleteAgendamentoAnalise', { id });
      NotificationManager.success('Agendamento deletado com sucesso', 'Sucesso');
      setShowEventModal(false);
      setSelectedAg(null);
      getAgendamentosAnalise();
    } catch (error) {
      NotificationManager.error('Erro ao deletar agendamento', 'Erro');
    }
  };

  const legenda = useMemo(() => {
    const ids = Array.from(new Set(events.map((e) => e.colaborador).filter(Boolean)));
    return ids.map((id) => ({
      nome: usuariosByCpf.get(String(id)) || id,
      cor: getColorFor(id),
    }));
  }, [events, usuariosByCpf, getColorFor]);

  const CustomToolbar = ({ onNavigate, onView: onToolbarView, view: toolbarView }) => {
    const goToBack = () => onNavigate('PREV');
    const goToToday = () => onNavigate('TODAY');
    const goToNext = () => onNavigate('NEXT');

    const isActive = (v) => v === toolbarView;

    const baseBtn = {
      marginRight: 10,
      border: '2px solid #A5A5A5',
      borderRadius: 20,
      padding: '6px 12px',
      fontWeight: 600,
      cursor: 'pointer',
      background: '#fff',
    };

    const activeBtn = {
      ...baseBtn,
      borderColor: 'var(--corPrimaria)',
      background: 'var(--corPrimaria)',
      color: '#fff',
    };

    return (
      <div
        className="rbc-toolbar"
        style={{
          marginBottom: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        <div>
          <button
            className={styles.cadastroCliente}
            onClick={() => openRegistro(new Date())}
            style={{
              background: 'var(--corPrimaria)',
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              padding: '10px 14px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Acrescentar
          </button>
        </div>

        <div>
          <span className="rbc-btn-group">
            <button style={baseBtn} onClick={goToBack}>Anterior</button>
            <button style={baseBtn} onClick={goToToday}>Hoje</button>
            <button style={baseBtn} onClick={goToNext}>Próximo</button>
          </span>
        </div>

        <div>
          <span className="rbc-btn-group">
            <button
              style={isActive('month') ? activeBtn : baseBtn}
              onClick={() => onToolbarView('month')}
            >
              Mês
            </button>
            <button
              style={isActive('week') ? activeBtn : baseBtn}
              onClick={() => onToolbarView('week')}
            >
              Semana
            </button>
            <button
              style={isActive('day') ? activeBtn : baseBtn}
              onClick={() => onToolbarView('day')}
            >
              Dia
            </button>
          </span>
        </div>
      </div>
    );
  };

  const onlyDigits = useCallback((s) => String(s || '').replace(/\D/g, ''), []);

  const formatPhoneBR = useCallback((raw) => {
    const d = onlyDigits(raw);
    if (!d) return '';

    if (d.startsWith('55') && d.length >= 12) {
      const cc = '55';
      const ddd = d.slice(2, 4);
      const rest = d.slice(4);

      if (rest.length >= 11) {
        return `+${cc} ${ddd} ${rest.slice(0, 5)}-${rest.slice(5, 9)}`;
      }
      if (rest.length >= 10) {
        return `+${cc} ${ddd} ${rest.slice(0, 4)}-${rest.slice(4, 8)}`;
      }
      return `+${cc} ${ddd} ${rest}`;
    }

    return `+${d}`;
  }, [onlyDigits]);

  const obsToPlainText = useCallback((obs) => {
    let s = obs;

    for (let i = 0; i < 3; i += 1) {
      if (typeof s === 'string') {
        const t = s.trim();
        try {
          if (t.startsWith('{') || t.startsWith('[') || t.startsWith('"')) {
            s = JSON.parse(t);
            continue;
          }
          return t;
        } catch {
          return t;
        }
      } else if (s && typeof s === 'object') {
        try {
          return JSON.stringify(s);
        } catch {
          return String(s);
        }
      } else {
        return String(s ?? '');
      }
    }

    return String(s ?? '');
  }, []);

  const inferTipo = useCallback((tipo, obs) => {
    if (tipo) return String(tipo).toLowerCase();

    const o = obsToPlainText(obs).toLowerCase();
    if (o.includes('trein')) return 'treinamento';
    if (o.includes('revers')) return 'reversão de negativa';
    if (o.includes('re-anal')) return 're-análise de perfil';
    if (o.includes('anal')) return 'análise de perfil';
    return 'análise de perfil';
  }, [obsToPlainText]);

  const statusEmoji = useCallback((status, tipo, obs) => {
    if (Number(status) === 2) return ' ✅';
    const t = (tipo || '').toLowerCase();
    const o = obsToPlainText(obs).toLowerCase();
    if (t.includes('revers') || o.includes('revers')) return '🆑';
    return '';
  }, [obsToPlainText]);

  const buildMonthClipboardText = useCallback(() => {
    if (!Array.isArray(agendamentos) || agendamentos.length === 0) return '';

    const list = agendamentos
      .filter((a) => isSameMonth(fromDiaHorario(a.dataDia, a.dataHorario), currentDate))
      .sort(
        (a, b) =>
          fromDiaHorario(a.dataDia, a.dataHorario) -
          fromDiaHorario(b.dataDia, b.dataHorario)
      );

    if (list.length === 0) return '';

    const groups = new Map();

    for (const a of list) {
      const d = fromDiaHorario(a.dataDia, a.dataHorario);
      const key = format(d, 'dd/MM');

      const hhmm = format(d, 'HH:mm');
      const tipo = inferTipo(a.tipo, a.observacoes);
      const nome = String(a.clienteNome || '').trim();
      const fone = formatPhoneBR(a.clienteContato);
      const emoji = statusEmoji(a.statusAnalise, tipo, a.observacoes);

      const line = `- ${hhmm} ${tipo} ${nome}${fone ? ` ${fone}` : ''}${emoji}`;

      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(line);
    }

    const days = Array.from(groups.keys()).sort((da, db) => {
      const [daD, daM] = da.split('/').map(Number);
      const [dbD, dbM] = db.split('/').map(Number);
      if (daM !== dbM) return daM - dbM;
      return daD - dbD;
    });

    const out = [];
    for (const day of days) {
      out.push(day);
      out.push(groups.get(day).join('\n'));
      out.push('');
    }

    return out.join('\n');
  }, [agendamentos, currentDate, fromDiaHorario, inferTipo, formatPhoneBR, statusEmoji]);

  const handleCopyMonth = async () => {
    const text = buildMonthClipboardText();
    if (!text.trim()) {
      NotificationManager.info('Sem eventos neste mês para copiar.', 'Info');
      return;
    }

    try {
      await navigator.clipboard.writeText(text);
      NotificationManager.success('Lista do mês copiada!', 'Copiado');
    } catch {
      try {
        const ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        NotificationManager.success('Lista do mês copiada!', 'Copiado');
      } catch {
        NotificationManager.error('Não foi possível copiar.', 'Erro');
      }
    }
  };

  const EventCard = ({ event }) => {
    const mins = event.start?.getMinutes?.() ?? 0;
    const startStr = mins === 0 ? format(event.start, 'H') : format(event.start, 'HH:mm');

    const tipoRaw = String(event.tipo ?? '').trim().toLowerCase();
    const tipo5 = tipoRaw.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    return (
      <div>
        <div
          title={`${startStr} · ${tipo5 || 'evento'}`}
          style={{
            fontWeight: 400,
            fontSize: '0.7rem',
            opacity: 0.9,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
          }}
        >
          {startStr} {tipo5 || 'evento'}
        </div>
        <div>{event.title}</div>
      </div>
    );
  };

  const toWhatsLink = useCallback((raw) => {
    if (!raw) return null;
    const d = String(raw).replace(/\D/g, '');
    const withDDI = d.startsWith('55') ? d : `55${d}`;
    return withDDI.length >= 12 ? `https://wa.me/${withDDI}` : null;
  }, []);

  return (
    <div className={styles.app}>
      <NotificationContainer />

      {showRegistro && (
        <div
          onClick={closeRegistro}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 'min(680px,95vw)',
              maxHeight: '85vh',
              overflow: 'auto',
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 10px 40px rgba(0,0,0,0.25)'
            }}
          >
            <RegistroAnalise
              initialDate={selectedDate}
              editData={editData}
              onComprovante={async (comp) => {
                const secureLink = await generateUniqueClientLink(comp.clienteId);

                setUniqueClientLink(secureLink);
                setComprovanteAnalise(comp);
                setShowComprovanteAnalise(true);
              }}
              onSuccess={() => {
                getAgendamentosAnalise();
                closeRegistro();
              }}
              onCancel={closeRegistro}
            />
          </div>
        </div>
      )}

      {showEventModal && selectedAg && (
        <div
          onClick={() => setShowEventModal(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 'min(560px,95vw)',
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 10px 40px rgba(0,0,0,0.25)',
              padding: 16
            }}
          >
            <h3 style={{ marginTop: 0 }}>Detalhes do agendamento</h3>

            <div style={{ lineHeight: 1.6 }}>
              <div><strong>({selectedAg.tipo})</strong></div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: '8px' }}>
                <strong>Link da Chamada:</strong>

                {selectedAg.meetLink ? (
                  <a
                    href={selectedAg.meetLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      background: 'rgb(0 111 193)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      padding: '6px 10px',
                      fontWeight: 700,
                      lineHeight: 1,
                      textDecoration: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                    }}
                  >
                    <img
                      src="/meetLogo.png"
                      alt="Google Meet Logo"
                      style={{ width: 20, height: 20 }}
                    />
                    Join Call
                  </a>
                ) : (
                  <span>sem link</span>
                )}
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: '8px' }}>
                <strong>Cliente:</strong>
                <span>{selectedAg.clienteNome}</span>

                {selectedAg.client_id && (
                  <a
                    href={`/formularios/${selectedAg.client_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      background: 'var(--corPrimaria)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      padding: '6px 10px',
                      fontWeight: 700,
                      lineHeight: 1,
                      textDecoration: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                    }}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
                      <path fill="currentColor" d="M14 3l7 7-7 7v-4H3v-6h11V3z" />
                    </svg>
                    Área do Cliente
                  </a>
                )}
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: '8px' }}>
                <strong>Contato:</strong>
                <span>{selectedAg.clienteContato}</span>

                {(() => {
                  const link = toWhatsLink(selectedAg?.clienteContato);
                  if (!link) return null;

                  return (
                    <a
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Abrir conversa no WhatsApp"
                      style={{
                        background: 'green',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 8,
                        padding: '6px 10px',
                        fontWeight: 700,
                        lineHeight: 1,
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                      }}
                    >
                      <svg width="14" height="14" viewBox="0 0 32 32" aria-hidden="true">
                        <path fill="currentColor" d="M19.1 17.3c-.3-.2-.6-.3-.9 0l-.6.6c-.3.3-.7.3-1.1.2-1-.4-2.3-1.3-3.2-2.4-.7-.8-1.2-1.8-1.4-2.5-.1-.4 0-.8.3-1l.5-.5c.3-.3.3-.6.1-.9l-1.5-2.4c-.2-.3-.5-.4-.8-.3-1.1.4-2 1.6-2 2.9 0 .6.2 1.3.5 2 .9 2.2 2.8 4.6 4.9 6.1 1.5 1.1 3 1.7 4.3 1.7 1.3 0 2.5-.7 3-1.8.1-.3 0-.6-.3-.8l-2.4-1.4Z" />
                        <path fill="currentColor" d="M26.9 5.1C24.1 2.3 20.4 1 16.7 1 9.3 1 3.3 7 3.3 14.5c0 2.4.7 4.8 2 6.9L3 30.6l9.4-2.3c2 1.1 4.3 1.7 6.6 1.7 7.5 0 13.5-6 13.5-13.5 0-3.7-1.3-7.4-4-10.2Zm-10.2 22c-2.1 0-4.1-.6-5.9-1.6l-.4-.2-5.6 1.4 1.5-5.4-.2-.4c-1.2-1.9-1.8-4.1-1.8-6.3C4.3 8 9.8 2.5 16.7 2.5c3.3 0 6.4 1.3 8.7 3.6 2.3 2.3 3.6 5.4 3.6 8.7 0 6.8-5.5 12.3-12.3 12.3Z" />
                      </svg>
                      WhatsApp
                    </a>
                  );
                })()}
              </div>

              <div style={{ marginBottom: '8px' }}>
                <strong>Vendedor:</strong>{' '}
                {usuariosByCpf.get(String(selectedAg.vendedor || '').replace(/\D/g, '')) || selectedAg.vendedor}
              </div>

              <div style={{ marginBottom: '8px' }}>
                <strong>Produtor:</strong>{' '}
                {usuariosByCpf.get(String(selectedAg.produtor || '').replace(/\D/g, '')) || selectedAg.produtor}
              </div>

              <div style={{ marginBottom: '8px' }}>
                <strong>Data:</strong>{' '}
                {(() => {
                  const data = fromDiaHorario(selectedAg?.dataDia, selectedAg?.dataHorario);
                  return isNaN(data) ? 'Data inválida' : format(data, "dd/MM/yyyy HH:mm");
                })()}
              </div>

              {selectedAg.observacoes && (
                <div style={{ marginBottom: '8px' }}>
                  <strong>Observações:</strong>{' '}
                  {(() => {
                    try {
                      const parsed = JSON.parse(selectedAg.observacoes);
                      return typeof parsed === 'string' ? parsed : JSON.stringify(parsed);
                    } catch {
                      return String(selectedAg.observacoes);
                    }
                  })()}
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }}>
              <button
                onClick={() => openEditarAgendamento(selectedAg)}
                className={styles.editButton}
              >
                Editar
              </button>

              <button
                onClick={() => excluirAgendamento(selectedAg.id)}
                className={styles.deleteButton}
              >
                Excluir
              </button>

              <button
                onClick={() => setShowEventModal(false)}
                className={styles.cancelButton}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={styles.cadastroClienteContainer}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
          <h2 style={{ margin: 0 }}>
            Análises {format(currentDate, 'MMMM yyyy', { locale: ptBR }).replace(/^./, (char) => char.toUpperCase())}
          </h2>

          <button
            onClick={handleCopyMonth}
            className={styles.cadastroCliente}
            title="Copiar mês atual"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 12px', color: '#fff', width: '100px' }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M16 1H4c-1.1 0-2 .9-2 2v12h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
            </svg>
            Copiar
          </button>
        </div>

        <Calendar
          localizer={localizer}
          culture="pt-BR"
          events={events}
          startAccessor="start"
          endAccessor="end"
          selectable
          onSelectEvent={handleEventClick}
          views={['month', 'week', 'day']}
          view={view}
          onView={setView}
          defaultView="month"
          step={60}
          timeslots={1}
          onNavigate={(date) => setCurrentDate(date)}
          min={minTime}
          max={maxTime}
          messages={messages}
          formats={formats}
          showMultiDayTimes
          allDayAccessor={null}
          style={{ height: "75vh", width: "90%", maxWidth: 600, fontSize: ".8rem" }}
          eventPropGetter={(event) => {
            const bg = getColorFor(event.colaborador);
            const color = getTextColor(bg);
            return {
              style: {
                backgroundColor: bg,
                borderColor: bg,
                color,
                fontWeight: 500
              }
            };
          }}
          components={{
            toolbar: CustomToolbar,
            event: EventCard,
          }}
        />

        {legenda.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, margin: '8px 0' }}>
            {legenda.map((item) => (
              <div
                key={item.nome}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  background: item.cor,
                  borderRadius: 4,
                  color: getTextColor(item.cor),
                  padding: "10px"
                }}
              >
                <p style={{ fontSize: "1rem", fontWeight: "600" }}>{item.nome}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      {showComprovanteAnalise && comprovanteAnalise && (
        <div
          className={`${styles.cadastroClienteContainer} ${styles.copiar}`}
          onClick={copyComprovanteAnalise}
          title="Clique para copiar"
          style={{ marginTop: 12 }}
        >
          <div
            className={styles.copiarTop}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          >
            <span>COMPROVANTE DA ANÁLISE (clique para copiar)</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowComprovanteAnalise(false);
              }}
              className={styles.cancelButton}
              style={{ marginLeft: 8 }}
            >
              Fechar
            </button>
          </div>

          <p
            id="copiarAnaliseExterno"
            className={styles.copiarText}
            style={{ whiteSpace: 'pre-line', fontSize: '1.2rem', fontWeight: 600 }}
          >
            {comprovanteAnalise.dataFmt} {comprovanteAnalise.tipo}<br />
            Link da Área do Cliente: {uniqueClientLink || 'sem link'}



            <br />
            Link da Video-Chamada: {comprovanteAnalise.meetLink || 'sem link'}
            <br />
            <br />
            {comprovanteAnalise.clienteNome} <br />
            {comprovanteAnalise.clienteContato && <>{comprovanteAnalise.clienteContato}<br /></>}
            Vendedor: {comprovanteAnalise.vendedorNome || comprovanteAnalise.vendedorCpf}<br />
            Produtor: {comprovanteAnalise.produtorNome || comprovanteAnalise.produtorCpf}<br />
            <br />
            Observações:<br />
            {comprovanteAnalise.observacoes || '—'}<br />
            <br />
            Gerado em: {comprovanteAnalise.geradoEm}
          </p>
        </div>
      )}
    </div>
  );
}

export default Analise;